import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import SearchBar from './SearchBar.js';
import Container from '@material-ui/core/Container';
import backgroundImg from '../../../assets/background-hero.svg';
import backgroundImgMobile from '../../../assets/background-hero-mobile.svg';
import Button from '../../../components/Button';

const useStyles = makeStyles(theme => ({
  root: {
    height: '42rem',
    width: '100%',
    paddingTop: '3rem',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    border: 'none',
    zIndex: 0,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
    backgroundSize: 'cover',
    backgroundImage: `url(${backgroundImg})`,
    [theme.breakpoints.down('sm')]: {
      margin: '0 0 4rem 0',
      padding: '1rem 0 0 0',
      height: '100%',
      minHeight: '90rem',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom center',
      backgroundSize: 'contain',
      backgroundImage: `url(${backgroundImgMobile})`,
    },
  },
  section: {
    paddingBottom: '4rem',
    [theme.breakpoints.down('sm')]: {
      padding: '0 1rem 4rem 1rem',
    },
  },
  stats: {
    position: 'relative',
    top: '4rem',
    left: '11.5rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      position: 'static',
      padding: '0 1rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
  },
  button: {
    padding: '0.7rem 1rem',
    margin: '1rem 0 2rem 0',
    [theme.breakpoints.down('sm')]: {
      margin: '1.5rem 0 3rem 0',
      width: '100%',
    },
  },
  textButton: {
    padding: '1rem 0',
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      textDecoration: 'underline',
    },
  },
  stat: {
    color: theme.palette.common.darkSlateBlue,
  },
  statText: {
    marginBottom: '2rem',
    width: '12rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '16rem',
    },
  },
}));


const HeroSection = () => {
  const classes = useStyles();
  return (
    <div className={classes.root} aria-hidden="true">
      <Container maxWidth="lg" fixed disableGutters={true}>
        <Grid container spacing={0}>
          <Grid item md={6} sm={12}>
            <div className={classes.section}>
              <Typography variant="h1" color="primary" gutterBottom>
                Find the right provider for you.
              </Typography>
              <Typography variant="body2" gutterBottom>
                Looking for supports? Answer these quick questions and our friendly team will be in touch to connect you with your perfect provider.
              </Typography>
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                label="Help me find service matches"
                to="/requestmatch"
              />
              <Typography variant="body2" gutterBottom>
                Or you can search below to view provider profiles, listings and reviews.
              </Typography>
              <SearchBar />
            </div>
            <div className={classes.section}>
              <Typography variant="h1" color="primary" gutterBottom>
                The disability services marketplace with a difference.
              </Typography>
              <Typography variant="body2" gutterBottom>
                Clickability is changing the way that people with disability find and manage NDIS services. We want to make your NDIS journey easier - using technology that gives you real, meaningful choice. Contact us if you want to know more! We&apos;re here to help.
              </Typography>
              <Button
                label="Find out more"
                to="/about"
                variant="text"
                className={classes.textButton}
              />
            </div>
          </Grid>
          <Grid item md={6} sm={12}>
            <div className={classes.stats}>
              <Typography variant="h1" className={classes.stat}>
                8,000+
              </Typography>
              <Typography variant="body2" className={classes.statText}>
                Service listed on Clickability
              </Typography>
              <Typography variant="h1" className={classes.stat}>
                130,000+
              </Typography>
              <Typography variant="body2" className={classes.statText}>
                Participants, carers and providers helped by Clickability
              </Typography>
              <Typography variant="h1" className={classes.stat}>
                3,000+
              </Typography>
              <Typography variant="body2" className={classes.statText}>
                Rating and reviews by service users
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default HeroSection;
